export default {
  title: '河南省人力资源和社会保障',
  subtitle: '河南省人力资源和社会保障',
  copyright: 'Copyright © 2022 daheyun.com. All rights reserved.',
  isFirstPage: true,// 配置首页不可关闭
  key: 'rs', // 配置主键,目前用于存储
  validateCode: true,//是否开启验证码校验
  register: true, //是否开启注册
  connectSync: true, //是否开启互联同步
  domainAutoTenant: false,// 是否根据 domain 自动匹配租户
  formLoginClient: 'pig:pig',// 用户名密码登录的 client 信息
  vite_pwd_enc_key: 'pigxpigxpigxpigx',// 前端加密密钥
  smsLoginClient: 'app:app',// 验证码登录的 client 信息
  socialLoginClient: 'social:social',// 社交登录的 client 信息
  websocket: false, // 是否开启websocket
  whiteList: ['/login', '/404', '/401', '/lock'], // 配置无权限可以访问的页面
  whiteTagList: ['/login', '/404', '/401', '/lock'], // 配置不新增tags页面 （'/advanced-router/mutative-detail/*'——*为通配符）
  fistPage: {
    label: '工作台',
    value: '/wel/index',
    params: {},
    query: {},
    group: [],
    close: false
  },
  // 配置菜单的属性
  menu: {
    props: {
      label: 'label',
      path: 'path',
      icon: 'icon',
      children: 'children'
    }
  }
}
